<template>
  <div id="wrapper">
    <SectionHeader
      :text="$t('media.brandingKit')"
      :back-text="$t('media.brandingKitBack')"
    />
    <Loading v-if="!data" />
    <div v-if="data" class="branding-kit-wrapper">
      <div class="branding-kit" v-for="item in data" :key="item.id">
        <div class="description">{{ item.description }}</div>
        <div class="image">
          <img :src="item.thumbnail" />
          <a :href="item.file" target="_blank">{{ $t("media.download") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../SectionHeader";
import Loading from "../Loading";

export default {
  name: "BrandingKit",
  components: { Loading, SectionHeader },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http
      .get("branding-kit/")
      .then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
#wrapper {
  padding: 10vh 0 20vh;
}

.branding-kit-wrapper {
  width: 800px;
  margin: 0 auto;
}

.image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 10vh 10vw;
  position: relative;
}

a {
  background: black;
  color: white;
  margin: 0 auto;
  padding: 18px 23px;
  position: absolute;
  bottom: -25px;
  width: 30%;
  text-align: center;
  text-decoration: none;
}

a:hover {
  background: #585858;
}
</style>
